// This is the most interesting function in the world
const identity = (i) => i

export default identity
